import axios from "axios";
import AuthHelper from "./AuthHelper";

const ApiHelper = {
  getRequest: (endpoint) => {
    const baseUrl = process.env.API_URL;
    const path = `${baseUrl}api/${endpoint}`;
    console.log(path);
    return axios.get(path, {
      headers: { Authorization: `Bearer ${AuthHelper.getUserToken()}` }
    });
  },
  postRequest: (endpoint, body) => {
    const baseUrl = process.env.API_URL;
    const path = `${baseUrl}api/${endpoint}`;
    console.log(path);
    return axios({
      method: "post",
      url: path,
      data: body
    });
  }
};

export default ApiHelper;
